import { getJson, sendJson } from '@/lib/api';
import { REPEAT_CLIENTS_PATH } from '@/lib/repeat-clients';

/**
 * A rep's reach-out playbook: the skill their repeat-client drafts follow
 * (which template for which situation, what to bring in, what they look
 * for, and their voice). Managed from Repeat clients. Mirrors the API's
 * outreach-playbook module.
 */

export const OUTREACH_PLAYBOOK_PATH = `${REPEAT_CLIENTS_PATH}/playbook`;

/** Field limits, matching the API's schema. */
export const OUTREACH_PLAYBOOK_LIMITS = {
  voiceChars: 4_000,
  lookForChars: 4_000,
  situations: 30,
  situationChars: 300,
  noteChars: 1_000,
} as const;

export interface PlaybookSituation {
  /** An outcome key from Repeat clients (booked, lost:<reason>, stage:<name>), or '' when described. */
  readonly outcome: string;
  /** The situation in the rep's words; required when there is no outcome. */
  readonly description: string;
  /** The template to use; null lets the draft pick. */
  readonly templateId: string | null;
  readonly note: string;
}

export interface OutreachPlaybook {
  readonly voice: string;
  readonly situations: readonly PlaybookSituation[];
  readonly context: readonly string[];
  readonly lookFor: string;
  /** Null until the rep saves one (the defaults are shown). */
  readonly updatedAt: string | null;
}

export interface ContextOption {
  readonly key: string;
  readonly label: string;
}

export interface PlaybookResponse {
  readonly playbook: OutreachPlaybook;
  readonly contextOptions: readonly ContextOption[];
}

export const PLAYBOOK_QUERY_KEY = ['outreach-playbook'] as const;

export const readPlaybook = (signal?: AbortSignal): Promise<PlaybookResponse> =>
  getJson<PlaybookResponse>('/outreach-playbook', undefined, signal);

export const savePlaybook = (playbook: Omit<OutreachPlaybook, 'updatedAt'>): Promise<OutreachPlaybook> =>
  sendJson<OutreachPlaybook>('put', '/outreach-playbook', playbook);
